var _excluded = ["markers", "visibleMarkers", "setVisibleMarkers", "sidebarMarkers", "setSidebarMarkers", "selectedMarkerButton", "setSelectedMarkerButton", "searchInput", "setSearchInput", "setActiveMarkerGroup"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useState } from 'react';
var searchIcon = function searchIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 19 19",
    className: "w-5 h-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1458 12.0833H12.3229L12.0312 11.8021C13.0521 10.6146 13.6667 9.07292 13.6667 7.39583C13.6667 3.65625 10.6354 0.625 6.89583 0.625C3.15625 0.625 0.125 3.65625 0.125 7.39583C0.125 11.1354 3.15625 14.1667 6.89583 14.1667C8.57292 14.1667 10.1146 13.5521 11.3021 12.5312L11.5833 12.8229V13.6458L16.7917 18.8438L18.3438 17.2917L13.1458 12.0833ZM6.89583 12.0833C4.30208 12.0833 2.20833 9.98958 2.20833 7.39583C2.20833 4.80208 4.30208 2.70833 6.89583 2.70833C9.48958 2.70833 11.5833 4.80208 11.5833 7.39583C11.5833 9.98958 9.48958 12.0833 6.89583 12.0833Z"
  }));
};
var closeIcon = function closeIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    className: "w-4 h-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"
  }));
};
var Search = function Search(_ref) {
  var markers = _ref.markers,
    visibleMarkers = _ref.visibleMarkers,
    setVisibleMarkers = _ref.setVisibleMarkers,
    sidebarMarkers = _ref.sidebarMarkers,
    setSidebarMarkers = _ref.setSidebarMarkers,
    selectedMarkerButton = _ref.selectedMarkerButton,
    setSelectedMarkerButton = _ref.setSelectedMarkerButton,
    searchInput = _ref.searchInput,
    setSearchInput = _ref.setSearchInput,
    setActiveMarkerGroup = _ref.setActiveMarkerGroup,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(searchIcon),
    _useState2 = _slicedToArray(_useState, 2),
    icon = _useState2[0],
    setIcon = _useState2[1];
  var getFilteredMarkers = function getFilteredMarkers(m) {
    var filteredMarkers = {};
    Object.keys(m).forEach(function (markerType) {
      filteredMarkers[markerType] = markers[markerType].filter(function (marker) {
        var properties = marker.properties;
        var name = properties.name;
        return name.toLowerCase().includes(searchInput.toLowerCase());
      });
    });
    return filteredMarkers;
  };
  var searchItems = function searchItems() {
    if (searchInput !== '') {
      setVisibleMarkers(getFilteredMarkers(markers));
      setSidebarMarkers(getFilteredMarkers(sidebarMarkers));
    } else {
      setVisibleMarkers(markers);
      setSidebarMarkers(markers);
    }
  };
  useEffect(function () {
    searchItems();
    setIcon(searchInput !== '' ? closeIcon() : searchIcon());
    if (searchInput !== '') {
      setActiveMarkerGroup('');
      if (selectedMarkerButton) {
        setSelectedMarkerButton(false);
      }
    } else {
      setSelectedMarkerButton(false);
    }
  }, [searchInput]);
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement("div", {
    className: "relative flex justify-end pb-2 border-b border-black"
  }, /*#__PURE__*/React.createElement("input", {
    className: ['block', 'w-full', 'text-base lg:text-lg', 'bg-transparent', 'placeholder-black hocus:placeholder-grey', 'outline-none', 'transition'].join(' '),
    value: searchInput,
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      setSearchInput(target.value);
    },
    onFocus: function onFocus() {
      setActiveMarkerGroup('');
      if (searchInput === '') {
        setVisibleMarkers(markers);
      }
    },
    placeholder: "Search the map"
  }), /*#__PURE__*/React.createElement("button", {
    className: "absolute flex items-center justify-center w-5 pb-2 h-full",
    onClick: function onClick() {
      return setSearchInput('');
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex"
  }, icon))));
};
export default Search;